// if remittance is created then id in selectedRemittances is a number
export const isRemittanceDraft = (remittanceId) => typeof remittanceId === 'string';
export const isRemittanceCreated = (remittanceId) => typeof remittanceId === 'number';
